import React, { Component } from "react";
import PropTypes from "prop-types";
import ProfileBio from "./profile_bio";
import AngelInterest from "./angel_interest";
import AngelInvestmentTrend from "./angel_investment_trend";
import AboutForm from "./about_form";

class MyAboutPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false
    };
  }

  handleEditButtonClick = () => {
    this.setState(prevState => (
      { isEditing: !prevState.isEditing }
    ));
  };

  render () {
    const { isEditing } = this.state;
    const { profile, angel, isAboutShow } = this.props;

    return (
      <section className='row d-flex justify-content-center' id='about' name='about'>
        <div className='col-12 col-sm-10'>
          <h2>
            ABOUT
            { isEditing === false && (
              <button type='button' className='btn-profile-edit' onClick={this.handleEditButtonClick}>
                <span className='d-none d-md-inline'>自己紹介を</span>
                編集
              </button>
            )}
          </h2>

          { isEditing === true && (
            <AboutForm
              {...this.props}
              handleEditButtonClick={this.handleEditButtonClick}
            />
          )}

          { isEditing === false && (
            <React.Fragment>
              { isAboutShow() ? (
                <React.Fragment>
                  <ProfileBio bio={profile.bio} />
                  <AngelInterest interest={angel.interest} />
                  <AngelInvestmentTrend investmentTrend={angel.investment_trend} />
                </React.Fragment>
              ) : (
                <button type='button' className='container content-null' onClick={this.handleEditButtonClick}>
                  <p>
                    <i className="fas fa-edit mr-1" />
                    あなたの情報を追加しましょう
                  </p>
                </button>
              )}
            </React.Fragment>
          )}
        </div>
      </section>
    );
  }
}

MyAboutPage.propTypes = {
  profile: PropTypes.shape({
    bio: PropTypes.string
  }).isRequired,
  angel: PropTypes.shape({
    interest: PropTypes.string,
    investment_trend: PropTypes.string
  }).isRequired,
  isAboutShow: PropTypes.func.isRequired
};

export default MyAboutPage;
